import {
  CLEAR_TIMESHIFT_EVENT_INFO,
  SET_TIMESHIFT_EVENT_INFO,
} from '../actions/timeShift/constants';

const initialState = {
  eventInfo: null,
};

const timeshift = (state = initialState, action) => {
  switch (action.type) {
    case SET_TIMESHIFT_EVENT_INFO:
      return { ...state, eventInfo: action.payload };
    case CLEAR_TIMESHIFT_EVENT_INFO:
      return { initialState };
    default:
      return state;
  }
};
export default timeshift;
